export const QuestionType = {
  MCQ: "mcq",
  YESNO: "yes_no",
  CHECKBOX: "checkbox",
  SHORT: "short",
  LONG: "long",
  SLIDER: "slider",
};

export const StatusEnum = {
  QUEST_APPROVED: "Quest approved!",
  QUEST_REJECTED: "Quest rejected",
  WITHDRAW_SUCCESSFUL: "Withdrawal successful!",
  WITHDRAW_UNSUCCESSFUL: "Withdrawal unsuccessful!",
  TIMEOUT: "Quest timeout",
};

export const QuestType = {
  NUMBER: "NUMBER",
  TEXT: "TEXT",
}
